module.exports = __webpack_public_path__ + "static/img/cynthia.7385bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/cynthia.png
// module id = NzMz
// module chunks = 0